import axios from 'axios';
import { baseURL } from '../../env';
import { authAxios } from '../../utils/AxiosHelper';
import { clearHistory, navigateTo } from './NavAction';

import { LOGIN, LOGIN_DETAILS, RESET, SET_ERROR } from './types';

import Cookies from 'js-cookie';
import { Items, Storage } from '../../utils/StorageHelper';
import { getClinicData, setSelectedClinic } from './ClinicAction';
import { setSelectedPatient } from './UserAction';
import { cleanStorage, getClinicByUserId, isAdminClinic } from '../../utils/CFuncs';
import { urls } from '../../utils/Objects';
import { setSuccess } from './MessageAction';

// export const setClinic = (selectedClinic) => {
//   return (dispatch) => {
//     dispatch({ type: CLINIC, payload: selectedClinic });

//   };
// };

const handleErrorResponse = (error, dispatch, type) => {
  console.log('erro messaeg ');

  console.log(error.message);
  let errObj = error.response?.data?.errors;
  if (errObj && Object.keys(errObj).length > 0) {
    return dispatch({
      type,
      payload: Object.values(errObj).join(' '),
    });
  } else if (error.response) {
    dispatch({
      type,
      payload: error.response.data,
    });
  } else if (error.request) {
    console.log(error.request);
    dispatch({ type, payload: error.request });
  } else {
    dispatch({ type, payload: error.message });
  }
};

// for the user
export const updatePassword = (password, oldPassword) => {
  return (dispatch) => {
    // authAxios.defaults.headers.common.Authorization = `Bearer ${cookieToken}`;
    authAxios
      .post(baseURL + '/api/Account/updatepassword', {
        password,
        oldPassword,
      })
      .then((response) => {
        // console.log("Register Response Code:", response)
        console.log('Register Response:', response.data);
        console.log('upassword changed');
        dispatch(navigateTo('/'));
      })
      .catch((error) => {
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};

export const changePassword = (token, email, password) => {
  return (dispatch) => {
    // authAxios.defaults.headers.common.Authorization = `Bearer ${cookieToken}`;
    authAxios
      .post(baseURL + '/api/Account/changepassword', { token, email, password })
      .then((response) => {
        // console.log("Register Response Code:", response)
        dispatch(setSuccess('password changed successfully'));

        console.log('Register Response:', response.data);
        console.log('upassword changed');
        dispatch(navigateTo('/'));
      })
      .catch((error) => {
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};
export const register = (userData, updateIsLoadingCallback) => {
  updateIsLoadingCallback(true);
  return (dispatch) => {
    axios
      .post(baseURL + '/api/Account/register', {
        first_name: userData.fName,
        last_name: userData.lName,
        username: userData.userName,
        email: userData.email,
        password: userData.password,
      })
      .then((response) => {
        // console.log("Register Response Code:", response)
        console.log('Register Response:', response.data);
        dispatch(setSuccess('your not confirmed yet ( paitents ) please check email  : ' + userData.email));
        updateIsLoadingCallback(false);
      })
      .catch((error) => {
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};

export const requestResetPasswrod = (email, onSucces = () => {}, onFail = () => {}) => {
  return (dispatch) => {
    dispatch({ type: LOGIN, payload: false });

    axios
      .post(baseURL + `/api/account/forgotpassword`, { email })
      .then((response) => {
        console.log(response.data);
        dispatch(setSuccess('Email has been sent to user to reset password'));

        onSucces('check your mail and click on link to reset passwrod!');
      })
      .catch((error) => {
        onFail();
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};

export const getToken = (userPayload,updateIsLoadingCallback =()=>{}) => {
  updateIsLoadingCallback(true);

  return (dispatch) => {
    cleanStorage();
    dispatch({ type: LOGIN, payload: false });

    axios
      .post(baseURL + '/api/account/auth', {
        email: userPayload.email,
        password: userPayload.pass,
      })
      .then((response) => {
        let isAuthenticated = response.data.isAuthenticated;
        let resToken = response.data.token;

        authAxios.defaults.headers.common.Authorization = `Bearer ${resToken}`;
        let refreshToken = response.data.refreshToken;
        if (isAuthenticated) {
          const loginUserObj = response.data;
          Cookies.set('auth', resToken);
          Cookies.set('refreshToken', refreshToken);
          dispatch({ type: LOGIN_DETAILS, payload: loginUserObj });
          dispatch({ type: LOGIN, payload: true });

          console.log('response.data');
          console.log(response.data);
          console.log('response.data.roles');
          console.log(response.data.roles);
          updateIsLoadingCallback(false);

          if (response.data.roles.includes('Administrator')) {
            dispatch(navigateTo(urls.clinics));
          } else if (response.data.roles.includes('HealthCareProvider')) {
            if (loginUserObj.emailConfirmed === false) {
              // Cookies.setItem("user", )
              dispatch(navigateTo(urls.resetPassword));
            } else {
              getClinicByUserId(response.data.id)
                .then((res) => {
                  Storage.set(Items.clinicId, res.id);

                  dispatch(getClinicData(res.id));

                  const clinic = response.data.clinics[0];
                  // const user = getUserFromToken()
                  dispatch(setSelectedClinic(clinic));
                  if (isAdminClinic()) {
                    dispatch(navigateTo(urls.clinicUsers, { clinic }));
                  } else {
                    dispatch(navigateTo(urls.clinicPatients, { clinic, user: response.data.id }));
                  }
                })
                .catch((err) => {
                  console.log('LOGIN_ERROR ' + err.message);
                  handleErrorResponse(err, dispatch, SET_ERROR);
                });
            }
          } else {
            //paitent
            dispatch(setSelectedPatient(response.data));
            dispatch(navigateTo(urls.patientDetails, { patient: response.data }));
          }
        }
      })
      .catch((error) => {
        handleErrorResponse(error, dispatch, SET_ERROR);
      });
  };
};

export const logout = () => {
  authAxios.defaults.headers.common.Authorization = ``;
  cleanStorage();
  return (dispatch) => {
    dispatch({
      type: RESET,
      payload: { isLogin: false, loginUser: null },
    });
    dispatch(navigateTo(''));
    dispatch(clearHistory());
  };
};
